import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

export const Drag: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 12 12">
    <path d="M5 1.5C5 2.32843 4.32843 3 3.5 3C2.67157 3 2 2.32843 2 1.5C2 0.671573 2.67157 0 3.5 0C4.32843 0 5 0.671573 5 1.5Z" />
    <path d="M5 5.5C5 6.32843 4.32843 7 3.5 7C2.67157 7 2 6.32843 2 5.5C2 4.67157 2.67157 4 3.5 4C4.32843 4 5 4.67157 5 5.5Z" />
    <path d="M5 9.5C5 10.3284 4.32843 11 3.5 11C2.67157 11 2 10.3284 2 9.5C2 8.67157 2.67157 8 3.5 8C4.32843 8 5 8.67157 5 9.5Z" />
    <path d="M10 1.5C10 2.32843 9.32843 3 8.5 3C7.67157 3 7 2.32843 7 1.5C7 0.671573 7.67157 0 8.5 0C9.32843 0 10 0.671573 10 1.5Z" />
    <path d="M10 5.5C10 6.32843 9.32843 7 8.5 7C7.67157 7 7 6.32843 7 5.5C7 4.67157 7.67157 4 8.5 4C9.32843 4 10 4.67157 10 5.5Z" />
    <path d="M10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5Z" />
  </SvgIcon>
);
